import { Emitter, Event } from "../../../../../features/event-emitter"
import { useAdministrationState } from "../../../hooks/administrationHooks"
import { Data2 } from "../../../../../features/data-types"
import { useExpenseService } from "../../../services/expenseService"

export const useActions = () => {
    const { currentEmployee } = useAdministrationState()

    const { createExpense } = useExpenseService()

    const submitExpense = async (
        data: Data2,
        branchId: string,
        subtotal: number,
        vatAmount: number,
        taxItemsData: Data2[],
        supplierId?: string,
        refundEmployeeId?: string,
        detail?: string,
        ticketFile?: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { name, expenseTypeId, date, total, ticketType, ticketDueDate } = data
        const expenseData = {
            name,
            expenseTypeId,
            date,
            branchId,
            amount: total,
            detail,
            employeeId: currentEmployee!.id,
            supplierId,
            refundEmployeeId
        }
        const ticketData = {
            type: ticketType,
            dueDate: ticketDueDate,
            subtotal,
            vatAmount,
            total,
            ticketFile
        }
        await createExpense(expenseData, ticketData, taxItemsData)

        Emitter.emit(Event.DB_SUBMIT_DONE, true)
    }
    
    return {
        submitExpense
    }
}
